import React, { useState } from "react";
import NewsTabs from "../Commons/NewsTabs/NewsTabs";
import UpdatesNews from "./UpdatesNews/UpdatesNews";
import SuggestionNews from "./SuggestionNews/SuggestionNews";
import PreSeasonNew from "./PreSeasonNew/PreSeasonNew";

export default function News() {
  const [selectedTab, setSelectedTab] = useState(0);
  const handleTabChange = (index: number) => {
    setSelectedTab(index);
  };
  const seasonType = "pre";

  const tabs = [
    {
      label: "UPDATES",
      content: <UpdatesNews />,
      eventName: "update_news_view",
      eventDesccription: "",
    },
    {
      label: "SUGGESTIONS",
      content: <SuggestionNews />,
      eventName: "suggestion_news_view",
      eventDescription: "",
    },
  ];

  return (
    <>
      {seasonType === "pre" ? (
        <PreSeasonNew />
      ) : (
        <div className="pt-3">
          <NewsTabs tabs={tabs} onTabChange={handleTabChange} />
        </div>
      )}
    </>
  );
}
